<h2 matDialogTitle class="mat-h2">Shopify Sync Results</h2>

<mat-dialog-content>
  <mat-divider></mat-divider>
  <div class="top-inputs">
    <mat-form-field>
      <mat-label>Status</mat-label>
      <mat-select [formControl]="statusSelectControl">
        <mat-option value="all">All</mat-option>
        <mat-option value="success">Success</mat-option>
        <mat-option value="failed">Failed</mat-option>
      </mat-select>
    </mat-form-field>
    <button mat-icon-button (click)="onDownloadClick()"><mat-icon color="accent">download</mat-icon></button>
  </div>
  <div class="loading-shade-container">
    @if (isLoadingResults()) {
      <div class="loading-shade">
        <mat-spinner color="accent"></mat-spinner>
      </div>
    }
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z1">

      <ng-container matColumnDef="discount_source_id">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Shopify Discount ID</th>
        <td mat-cell *matCellDef="let row"> {{ row.discount_source_id }}</td>
      </ng-container>

      <ng-container matColumnDef="discount_sync_log_result">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          {{ row.discount_sync_log_result | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="discount_name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Discount Title</th>
        <td mat-cell *matCellDef="let row" style="word-break: break-all">
          {{ row.discount_name | titlecase }}
        </td>
      </ng-container>

      <ng-container matColumnDef="coupon_code">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Coupon Code</th>
        <td mat-cell *matCellDef="let row" style="word-break: break-all">
          {{ row.coupon_code }}
        </td>
      </ng-container>

      <ng-container matColumnDef="discount_sync_log_message">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>File Message</th>
        <td mat-cell *matCellDef="let row" style="word-break: break-all">
          {{ row.discount_sync_log_message }}
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        @if (isLoadingResults()) {
          <td class="mat-mdc-cell" [attr.colspan]="5">loading...</td>
        }
        @if (!isLoadingResults()) {
          <td class="mat-mdc-cell" [attr.colspan]="5">There are no Shopify log items.</td>
        }
      </tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]" pageSize="5" showFirstLastButtons></mat-paginator>
  </div>
  <div class="button-group">
    <button mat-raised-button mat-dialog-close color="primary">Close</button>
  </div>
</mat-dialog-content>
